import React, { useContext, useEffect, useState } from 'react';
import './index.scss';
import useViewType from '@/utils/Hooks/useViewType';
import ModalDarkScreen from '../ModalDarkScreen';
import { projectImages } from '../../../../public/Assets/Images';
const SideModal = (props: any) => {
  // const { compoentRef, setIsModalOpen } = useContext<any>(FreeUserDashboardContext);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCloseModal, setIsCloseModal] = useState(false);
  const isMobile = useViewType(800);
  const handleCloseClick = () => {
    const body = document?.getElementsByTagName("body")[0];
    body.classList.remove("overscroll-none");
    setIsCloseModal(true);
    setTimeout(() => {
      setIsModalOpen(false);
    }, 100);
  };
  const getClassName = () => {
    let className = '';
    if (isMobile) {
      className += 'mobile_modal';
      return className;
    }
    isCloseModal ? className += 'close_modal' : className += 'modal_content';
    return className;
  };
  useEffect(() => {
    const body = document?.getElementsByTagName("body")[0];
    body.classList.add("overscroll-none");
  }, []);
  return <ModalDarkScreen styles={{
    display: "flex",
    justifyContent: isMobile ? "center" : "flex-end",
    flexDirection: "row"
  }} closeOnClick closehandler={props.clickHandler} data-sentry-element="ModalDarkScreen" data-sentry-component="SideModal" data-sentry-source-file="index.tsx">
      <div className='side_modal_content_wrapper'>
        {!isMobile && <div className="close_icon_wrapper">
          <img src={projectImages.closeiconmedium} loading='lazy' alt="close" onClick={() => props.clickHandler()} />
        </div>}
        <div className="side_modal_content">
          {props.children}
        </div>
      </div>
    </ModalDarkScreen>;
};
export default SideModal;